// =============================================================================
// Home page carousels.
//
// Swiper drives the two home sections. The markup is already a finished CSS grid
// before this runs (see _slider.scss), so if the bundle fails to load the
// sections still show every card — this only adds the sliding and the arrows.
// =============================================================================

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

// The gaps the stylesheet uses for the same grids, so the carousel keeps the
// section's rhythm instead of introducing a second spacing scale.
const GAP = 20;
const GAP_MOBILE = 14;

// Matches $ch-tablet / $ch-mobile in _tokens.scss. Swiper's breakpoints are
// min-width, so these are the widths at which the next count takes over.
const TABLET_UP = 768;
const DESKTOP_UP = 1024;

function readConfig(root) {
	try {
		return JSON.parse(root.dataset.chSlider || '{}');
	} catch {
		// A malformed attribute should not cost the visitor the whole carousel.
		return {};
	}
}

function perView(value, fallback) {
	const parsed = Number(value);

	return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export default function initSliders() {
	const roots = document.querySelectorAll('[data-ch-slider]');

	roots.forEach((root) => {
		const viewport = root.querySelector('.swiper');

		if (!viewport) {
			return;
		}

		const config = readConfig(root);
		const desktop = perView(config.perView, 4);
		const tablet = perView(config.perViewTablet, desktop);
		const mobile = perView(config.perViewMobile, 2);

		new Swiper(viewport, {
			modules: [Navigation],
			// Mobile is the base; the breakpoints below step it up.
			slidesPerView: mobile,
			spaceBetween: GAP_MOBILE,
			// Fewer cards than fit on screen: Swiper locks itself and flags the
			// arrows, which _slider.scss then hides.
			watchOverflow: true,
			navigation: {
				prevEl: root.querySelector('[data-ch-slider-prev]'),
				nextEl: root.querySelector('[data-ch-slider-next]'),
			},
			breakpoints: {
				[TABLET_UP]: { slidesPerView: tablet, spaceBetween: GAP },
				[DESKTOP_UP]: { slidesPerView: desktop, spaceBetween: GAP },
			},
		});
	});
}
